import { StyleSheet, Platform } from "react-native";

const styles = StyleSheet.create({
  container: {
    paddingHorizontal: 22,
    marginTop: 12,
    alignSelf: "center",
    minHeight: 350,
    width: 350,
    borderRadius: 8,
    borderColor: "#FFF",
    borderWidth: 0.5,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 4,
    },
    shadowOpacity: 0.25,
    shadowRadius: 4.84,
    elevation: 4,
  },
  title: {
    textAlign: "center",
    fontSize: 16,
    fontWeight: "bold",
    marginTop: 20,
  },
  iconSelect: {
    width: 17,
    height: 18,
  },

  txtMeuSaldo: {
    textAlign: "left",
    textTransform: "uppercase",
    fontSize: 14,
  },

  contentSelect: {
    alignSelf: "center",
    zIndex: 9999,
    marginBottom: 20,
  },

  dropdown: {
    width: "350%",
    height: 30,
    marginTop: 15,
    zIndex: 9999,
  },
  textAmount: {
    fontSize: 18,
    color: "#5eb2a9",
    fontWeight: "bold",
    marginTop: 35,
  },
  price: {
    textAlign: "center",
    fontSize: 12,
    marginTop: 15,
  },

  contentBtn: {
    marginTop: 12,
    alignSelf: "center",
    alignItems: "center",
    paddingHorizontal: 4,
    width: 320,
  },
  btn: {
    fontFamily: "Poppins, sans-serif",
    padding: 10,
    width: 320,
    height: 38,
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 4,
    backgroundColor: "#077A97",
    marginVertical: 12,
    alignSelf: "center",
    color: "#fff",
  },
  textBtn: {
    color: "#fff",
    textAlign: "center",
    fontSize: 18,
    fontWeight: "500",
  },
  numberInput: {
    flex: 1,
    borderWidth: 1,
    borderColor: "#ccc",
  },
  contentPurchase: {
    paddingHorizontal: 0,
    marginTop: 20,
    alignSelf: "center",
  },
  titlePurchase: {
    textAlign: "center",
    marginBottom: 20,
  },
  contentPurchaseAmount: {
    alignSelf: "center",
    flexDirection: "row",
    justifyContent: "space-between",
  },
});

export default styles;
